import { render, staticRenderFns } from "./AddAttendanceType.vue?vue&type=template&id=b1c0f6b6"
import script from "./AddAttendanceType.vue?vue&type=script&lang=js"
export * from "./AddAttendanceType.vue?vue&type=script&lang=js"
import style0 from "./AddAttendanceType.vue?vue&type=style&index=0&id=b1c0f6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports